import { Modal, ModalCancelButton, ModalCloseButton, ModalConfirmButton, ModalWidth } from '@dreryk/react-components';

import { translationKeys } from '../../../translations';

import { CustomPatientGroupsCreateForm } from './CustomPatientGroupsCreateForm';
import { CustomPatientGroupsCreateAction } from './CustomPatientGroupsCreateModal.actions';

type CustomPatientGroupsCreateModalProps = { onClose: VoidFunction };

export const CustomPatientGroupsCreateModal = (props: CustomPatientGroupsCreateModalProps): JSX.Element => {
   return (
      <Modal title={translationKeys.addCustomGroup} width={ModalWidth.NORMAL} testId={'customPatientGroupsCreate'}>
         <CustomPatientGroupsCreateForm>
            {({ handleSubmit, formState, setNotUniqueCustomPatientGroupNameError }) => (
               <>
                  <CustomPatientGroupsCreateAction
                     onSuccess={props.onClose}
                     onPatientGroupAlreadyExistsFault={setNotUniqueCustomPatientGroupNameError}
                  >
                     {({ createCustomPatientGroup }) => (
                        <ModalConfirmButton
                           label={translationKeys.save}
                           onClick={handleSubmit(createCustomPatientGroup)}
                        />
                     )}
                  </CustomPatientGroupsCreateAction>

                  <ModalCancelButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
                  <ModalCloseButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
               </>
            )}
         </CustomPatientGroupsCreateForm>
      </Modal>
   );
};
